import { Box, styled } from "@mui/material";

export const StyledEnableAccountInputBox = styled(Box)(({ theme }) => ({
  width: "504px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

export const StyledEnableAccountDOBBox = styled(Box)(({ theme }) => ({
  width: "241px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

export const StyledEnableAccountContinueButtonBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  "&  .MuiBox-root": {
    flexBasis: "501px",
  },
}));
